export default function parseJson<T = unknown>(responseText: string): T | string {
  try {
    return JSON.parse(responseText) as T;
  } catch (e) {
    return responseText;
  }
}
